import React from 'react'

export default function Riskassessment() {
  return (
    <>
    <div className='md:px-10 px-5 overflow-hidden'>
        <div className='max-w-screen-xl mx-auto justify-center'>
            <div className='py-10 md:pt-20'>
                <h1 className='md:text-4xl text-xl mx-auto text-[#000] justify-center'>
                    Risk Assessment and Management 
                </h1>
                <h3 className='text-[#000000] md:text-xl text-base pt-5'>
                    Identifying Vulnerabilities, Fortifying Defenses
                </h3>
                <p className='text-[#474747] md:text-base text-sm pt-3'>
                    At Elite Crown Diamond, our cybersecurity services begin with a thorough risk assessment and management process. Our approach is designed to identify vulnerabilities within your digital infrastructure, assess the potential impact of various cyber threats, and implement effective strategies to manage and mitigate these risks.
                </p>
            </div>

            <div className='bg-[#e4e4e4] border md:px-10 px-5 py-10'>
                <div className='justify-center w-full mx-auto text-[#000]'>
                    <h1 className='md:text-2xl text-xl mx-auto text-[#000] justify-center'>
                        Key Features:
                    </h1>
                    <div className='md:grid grid-cols-2 md:gap-x-10 justify-between mx-auto mt-3'>
                        <div className='md:py-10 hover:bg-white duration-200 border-opacity-40 py-5 border-b border-[#d8bb6c] hover:translate-y-1 hover:px-5 hover:text-black cursor-wait'>
                            <span className='font-semibold md:text-xl text-lg border-b border-[#d8bb6c]'>
                                Customized Risk Assessments:
                            </span>
                            <p className='text-[#474747] md:text-base text-sm pt-3 hover:text-black'>
                                Tailored evaluations that consider your specific business context, technology stack, and industry threats.
                            </p>
                        </div>
                        <div className='md:py-10 hover:bg-white duration-200 border-opacity-40 py-5 border-b border-[#d8bb6c] hover:translate-y-1 hover:px-5 hover:text-black cursor-wait'>
                            <span className='font-semibold md:text-xl text-lg border-b border-[#d8bb6c]'>
                                Vulnerability Scanning:
                            </span>
                            <p className='text-[#474747] md:text-base text-sm pt-3 hover:text-black'>
                                Regular scans of your digital assets to identify and address vulnerabilities before they can be exploited.
                            </p>
                        </div>
                        <div className='md:py-10 hover:bg-white duration-200 border-opacity-40 py-5 border-b border-[#d8bb6c] hover:translate-y-1 hover:px-5 hover:text-black cursor-wait'>
                            <span className='font-semibold md:text-xl text-lg border-b border-[#d8bb6c]'>
                                Risk Management Strategies:
                            </span>
                            <p className='text-[#474747] md:text-base text-sm pt-3 hover:text-black'>
                                Development and implementation of robust risk management plans that prioritize threats and outline mitigation techniques.
                            </p>
                        </div>
                        <div className='md:py-10 hover:bg-white duration-200 border-opacity-40 py-5 border-b border-[#d8bb6c] hover:translate-y-1 hover:px-5 hover:text-black cursor-wait'>
                            <span className='font-semibold md:text-xl text-lg border-b border-[#d8bb6c]'>
                                Continuous Monitoring:
                            </span>
                            <p className='text-[#474747] md:text-base text-sm pt-3 hover:text-black'>
                                Ongoing surveillance of your digital environment to detect and respond to threats in real-time, ensuring your defenses are always up to date.
                            </p>
                        </div>
                    </div>
                    <div className='justify-center mx-auto w-full bg-[#c5c5c5] px-5 md:mt-10 mt-5'>
                        <div className='text-[#202020] max-w-screen-xl mx-auto justify-center md:py-20 py-10 text-center md:text-xl text-xs'>
                            <p>
                                Protect your digital assets and ensure the continuity of your operations with Elite Crown Diamond' cybersecurity services – your partner in navigating the complex cybersecurity landscape.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}
